import { Controller } from "stimulus"
import currency from '../helpers/currency'

export default class extends Controller {
  static targets = ["orderAmount", "totalAmount"]

  connect() {
    this.refreshTotals()
  }

  refreshTotals() {
    const totalAmount = this.orderAmountTargets
      .map(target => target.value)
      .map(amount => currency(amount))
      .reduce((a, b) => a.add(b), currency(0))

    this.totalAmountTarget.innerText = totalAmount.format()
  }
}
